document.addEventListener("DOMContentLoaded", function () {
  // Delegated click listener on the document body
  document.body.addEventListener("click", function (event) {
    const target = event.target;

    // Check if the clicked element is a .minus or .remove button (or inside one)
    const buttonElement = target.closest(".minus, .remove");
    if (!buttonElement) return;

    // Extract data attributes from the button element
    const item_name = buttonElement.getAttribute("data-item-name");
    const item_id = buttonElement.getAttribute("data-item-id");
    const item_price = buttonElement.getAttribute("data-price");
    const item_quantity = parseInt(buttonElement.getAttribute("data-quantity"), 10);
    const currency = document.querySelector(".quantity")?.getAttribute("data-currency") || "USD";

    // Validate essential data before proceeding
    if (!item_id || !item_price) {
      console.warn("Missing item data");
      return;
    }

    // Format price from cents to decimal
    const formattedPrice = parseFloat((item_price / 100).toFixed(2));

    // Build the event object for the dataLayer
    const eventData = {
      event: "remove_from_cart",
      ecommerce: {
        currency: currency,
        value: formattedPrice,
        items: [
          {
            item_name: item_name,
            item_id: item_id,
            price: formattedPrice,
            quantity: item_quantity,
          },
        ],
      },
    };

    // Push the event to the dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);
  });
});
